export default {
  "b2b.produkty-grid-columns.id.label": "Id",
  "b2b.produkty-grid-columns.nazev.label": "Název",
  "b2b.produkty-grid-columns.popis.label": "Popis",
  "b2b.produkty-grid-columns.zkratka.label": "Zkratka",
  "b2b.produkty-grid-columns.uzivaNapajeni.label": "Užívá napájení",
  "b2b.produkty-grid-columns.vylucny.label": "Výlučný",
  "b2b.produkty-grid-columns.parkovani.label": "Parkování",
  "b2b.produkty-grid-columns.bezCasu.label": "Bez času"
};
